<template>
  <button type="button" v-if="modern"
          class="rounded-md bg-green-50 px-3.5 py-2 text-sm font-semibold text-green-600 shadow-sm hover:bg-green-100">
    <slot/>
  </button>
  <button :type="type" v-else
          class="inline-flex items-center px-4 py-2 bg-primary border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-primary-600 focus:outline-none disabled:opacity-25 transition">
    <slot></slot>
  </button>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'submit',
    },
    modern: {
      type: Boolean,
      default: true,
    }
  }
})
</script>
